export const SortOrder = {
  Asc: 0,
  Desc: 1,
  Date: 2
} as const;

export const SortOrderLabels: Record<SortOrder, string> = {
 [SortOrder.Asc]: 'A-Z',
 [SortOrder.Desc]: 'Z-A',
 [SortOrder.Date]: 'Date'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
